module.exports = __webpack_public_path__ + "static/media/cog.500134b6.svg";